import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf"

// Tag add/remove inside the Files preview pane (FILES_DESIGN_SPEC.md - "a
// TAGS section with removable chips and a dashed + Add tag control").
// UserFileTagsController#create find-or-creates the Tag by name, so this
// covers both "attach an existing tag" and "make a new one" with the same
// request. A successful mutation dispatches "changed" rather than patching
// the chip list by hand - files_app_controller.js re-fetches this whole
// preview fragment in response (see its #refreshPreview), which keeps this
// controller from needing to duplicate _preview.html.slim's chip markup.
export default class extends Controller {
    static targets = ["addForm", "addButton", "addInput"]
    static values = { url: String }

    showAddForm(event) {
        event.preventDefault()
        this.addButtonTarget.hidden = true
        this.addFormTarget.hidden = false
        this.addInputTarget.value = ""
        this.addInputTarget.focus()
    }

    cancelAdd(event) {
        event?.preventDefault()
        this._closeAddForm()
    }

    add(event) {
        event.preventDefault()
        const name = this.addInputTarget.value.trim()
        if (!name) return

        fetch(this.urlValue, {
            method: "POST",
            headers: { Accept: "application/json", "Content-Type": "application/json", "X-CSRF-Token": csrfToken() },
            credentials: "same-origin",
            body: JSON.stringify({ name })
        })
            .then((response) => response.json())
            .then((data) => {
                if (data && data.ok) {
                    this.dispatch("changed")
                } else {
                    window.alert((data && data.error) || "Could not add that tag.")
                }
            })
            .catch(() => window.alert("Could not add that tag - check your connection."))
    }

    remove(event) {
        event.preventDefault()
        const tagId = event.currentTarget.dataset.tagId
        if (!tagId) return

        fetch(`${this.urlValue}/${encodeURIComponent(tagId)}`, {
            method: "DELETE",
            headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() },
            credentials: "same-origin"
        })
            .then((response) => response.json())
            .then((data) => {
                if (data && data.ok) {
                    this.dispatch("changed")
                } else {
                    window.alert((data && data.error) || "Could not remove that tag.")
                }
            })
            .catch(() => window.alert("Could not remove that tag - check your connection."))
    }

    _closeAddForm() {
        this.addFormTarget.hidden = true
        this.addButtonTarget.hidden = false
    }
}
